import { Children, cloneElement, isValidElement, memo, useContext } from 'react';
import type { PropsWithChildren } from 'react';

import { NodeRendererContext } from './RootRenderer';

export const NodeRenderer = memo(({ children, renderIndex, ...props }: NodeRendererProps) => {
	const shouldRenderNode = useContext(NodeRendererContext);
	const shouldRender = shouldRenderNode?.(renderIndex) ?? true;

	if (!shouldRender) {
		return null;
	}

	// Some node components add props to their children, outside of `serializeFragment`. Pass such props through:
	if (Object.keys(props).length) {
		return Children.map(children, (child) =>
			isValidElement(child) ? cloneElement(child, props) : child,
		);
	}

	return children;
});
NodeRenderer.displayName = 'NodeRenderer';

type NodeRendererProps = PropsWithChildren<{
	renderIndex: number;
}>;
